module.exports = __webpack_public_path__ + "img/bottom_of_the_form.383917db.png";